import React from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { captureUnhandledRejections, rootErrorHandlers } from "Store/LogStore";

captureUnhandledRejections();

const domNode = document.getElementById("index") ?? document.createElement("div");
const root = createRoot(domNode, {
    identifierPrefix: "OspApp-",
    ...rootErrorHandlers
});

root.render(<App />);
